import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { CdkDrag, CdkDragEnd } from "@angular/cdk/drag-drop";
import { CommonModule, NgStyle } from "@angular/common";
import { Router } from "@angular/router";
import { BackendApiService } from "../../../../app/services/backend-api.service";
import { PowerTrainService } from "../../../../app/services/powertrain.service";
import { BaseUrlConstantsService } from "../../../../app/services/base-url-constants.service";
import { Subscription } from "rxjs";
import { PowertrainModalComponent } from "../../powertrain-modal/powertrain-modal.component";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-edit-powertrain",
  templateUrl: "./edit-powertrain.component.html",
  styleUrls: ["./edit-powertrain.component.scss"],
  standalone:true,
  imports: [CommonModule, NgStyle,PowertrainModalComponent,CdkDrag,MatButtonModule]
})
export class EditPowertrainComponent implements OnInit {
  @ViewChild("canvasContainer") canvasContainer!: ElementRef;
  imagesUrl = BaseUrlConstantsService.POWERTRAIN_IMAGES_API;
  updatePositionurl = BaseUrlConstantsService.POWERTRAIN_UPDATE_POSITIONS_URL;

  selectedAsset: any = {};
  selectedSensor: any = {};
  openModal: boolean = false;
  private subscription = new Subscription();
  existingPowertrainObj: any = null;

  images = [
    {
      src: "./assets/powertrain-images/bearing.png",
      alt: "Bearing",
      asset_type: "JOURNAL_BEARING",
      sub_type: "",
    },
    // { src: '/assets/images/compressor.png', alt: 'Sensor' },
    {
      src: "./assets/powertrain-images/fan.png",
      alt: "Sensor",
      asset_type: "FAN_BLOWER",
      sub_type: "",
    },
    {
      src: "./assets/powertrain-images/gearbox.png",
      alt: "Sensor",
      asset_type: "GEAR",
      sub_type: "",
    },
    {
      src: "./assets/powertrain-images/motor.png",
      alt: "Sensor",
      asset_type: "MOTOR",
      sub_type: "",
    },
  ];
  powerTrainImages = [];
  sensors: any = [];
  canvasItems: any = [];
  oldTemplateSensorNumber: number = 0;

  powertrainCanvasItems: any = [];
  powertrainSensors: any = [];
  powertrainSelectedSensor: any = {};
  openPowertrainSensorModal: boolean = false;
  isPowerTrain: boolean = true;
  powerTrainSensorsNumber: number = 0;

  openPowertrainNameModal: boolean = false;
  powertrainName: string = "";
  addedMoreSensors: boolean = false;

  constructor(
    private router: Router,
    private service: BackendApiService,
    private powertrainService: PowerTrainService
  ) {}

  ngOnInit(): void {
    this.subscription = this.powertrainService.powertrainEditDataObs.subscribe(
      (data) => {
        console.log("EXISTING DATA")
        console.log(data)
        this.existingPowertrainObj = data;
      }
    );
    if (this.existingPowertrainObj) this.addImageToPowerTrainCanvas();
    this.selectPowerTrainType(true);
  }

  ngAfterViewInit(): void {
    this.observeContainerResize();
  }

  observeContainerResize(): void {
    const canvasContainer = this.canvasContainer.nativeElement;
    const observer = new ResizeObserver(() => {
      this.adjustPositionsOnResize();
    });
    observer.observe(canvasContainer);
  }

  adjustPositionsOnResize(): void {
    const canvasRect =
      this.canvasContainer.nativeElement.getBoundingClientRect();

    this.canvasItems.forEach((item: any) => {
      item.xPercent = (item.x / canvasRect.width) * 100;
      item.yPercent = (item.y / canvasRect.height) * 100;
    });

    this.sensors.forEach((sensor: any) => {
      sensor.xPercent = (sensor.x / canvasRect.width) * 100;
      sensor.yPercent = (sensor.y / canvasRect.height) * 100;
    });
  }

  addImageToCanvas(image: {
    src: string;
    alt: string;
    asset_type: string;
    sub_type: string | null | undefined;
  }): void {
    if (image.asset_type == "MOTOR") {
      {
        this.openModal = true;
      }
    }
    if (!this.canvasItems.length) {
      this.canvasItems.push({
        id: this.canvasItems.length,
        ...image,
        xPercent: 10,
        yPercent: 10,
        x: 0,
        y: 0,
        widthPercent: 20,
        sensors: [],
        asset_marker: "MASTER",
      });
    } else {
      this.canvasItems.push({
        id: this.canvasItems.length,
        ...image,
        xPercent: 10,
        yPercent: 10,
        x: 0,
        y: 0,
        widthPercent: 20,
        sensors: [],
        asset_marker: "CHILD",
      });
    }
  }

  onDragEnd(event: CdkDragEnd, item: any): void {
    const canvasRect =
      this.canvasContainer.nativeElement.getBoundingClientRect();
    const { x, y } = event.source.getFreeDragPosition();

    item.xPercent = Math.min(Math.max((x / canvasRect.width) * 100, 0), 100);
    item.yPercent = Math.min(Math.max((y / canvasRect.height) * 100, 0), 100);
    item.x = x;
    item.y = y;
  }

  // Handle Drag End for Sensors
  onSensorDragEnd(event: CdkDragEnd, sensor: any): void {
    const { x, y } = event.source.getFreeDragPosition();
    sensor.x = x;
    sensor.y = y;
  }

  // Add a Sensor to the Canvas
  addSensor(): void {
    if (!this.selectedAsset.asset_type) {
      this.service.showError("Please select an asset in canvas");
      return;
    }
    this.oldTemplateSensorNumber++;
    let selectedAss = this.canvasItems.filter(
      (item: any) => item.id == this.selectedAsset.id
    );
    this.sensors.push({
      id: this.sensors.length,
      sensor_number: this.sensors.length,
      xPercent: 10,
      yPercent: 10,
      width: 5,
      ...selectedAss[0],
    });

    selectedAss[0].sensors.push({
      id: this.sensors.length - 1,
      sensor_number: this.sensors.length - 1,
      xPercent: 10,
      yPercent: 10,
      width: 5,
      asset_marker: this.sensors.length - 1 == 0 ? "MASTER" : "CHILD",
    });
  }

  // Save Template
  saveTemplate(): void {
    let finalSensors = [];
    this.canvasItems.map((item) => {
      item.sensors.map((sensor) => {
        finalSensors.push({
          ...sensor,
          assetType: item.asset_type,
          subType: item.sub_type,
        });
      });
    });
    let subsystemEncodedData = encodeURIComponent(
      JSON.stringify({
        subsystem_name: this.powertrainName,
        client_id: localStorage.getItem("user_id"),
        Image_path: "",
        subsystem_uuid: localStorage.getItem("assetBatchID") || "",
        site_id: JSON.parse(localStorage.getItem("siteID")),
        application_id: JSON.parse(localStorage.getItem("applicationID")),
        subsystem_type: "asset",
      })
    );
    finalSensors.sort((a, b) => a.sensor_number - b.sensor_number);
    const encodedCanvasItems = encodeURIComponent(JSON.stringify(finalSensors));
    const encodedJson = encodeURIComponent(JSON.stringify(this.canvasItems));
    this.router.navigate(["/powertrain-create-form"], {
      queryParams: {
        data: encodedCanvasItems,
        type: "Create Asset",
        assetType: "asset",
        jsonData: encodedJson,
        subsytemTableData: subsystemEncodedData,
      },
      skipLocationChange: true,
    });
  }

  onSensorClick(sensor) {
    this.selectedSensor = sensor;
    sensor.clickCount = (sensor.clickCount || 0) + 1;
    setTimeout(() => {
      if (sensor.clickCount === 3) {
        this.deleteCanvasItem(sensor);
      }
      sensor.clickCount = 0;
    }, 300);
  }

  onCanvasItemClick(item: any): void {
    this.selectedAsset = item;
    item.clickCount = (item.clickCount || 0) + 1;

    setTimeout(() => {
      if (item.clickCount === 3) {
        this.deleteCanvasItem(item);
      }
      item.clickCount = 0;
    }, 300);
  }

  // Function to delete an item from the canvas
  deleteCanvasItem(item: any): void {
    const index = this.canvasItems.indexOf(item);
    if (index !== -1) {
      this.canvasItems.splice(index, 1);
    }
  }

  deleteCanvasSensor() {
    if (this.isPowerTrain) {
      this.powerTrainSensorsNumber == 0
        ? this.service.showError("No sensors added yet")
        : (this.powertrainCanvasItems[0].sensors = []);
      this.powerTrainSensorsNumber = 0;
    } else {
      this.sensors.length
        ? (this.sensors = [])
        : this.service.showError("No sensors added yet");

      this.canvasItems.forEach((item) => {
        item.sensors = [];
      });
    }
  }

  closeBox(data) {
    this.openModal = false;
    this.canvasItems[this.canvasItems.length - 1].sub_type = data.type;
  }

  /* --------------------------------------------------------------------POWERTRAIN DRAG DROP START */

  selectPowerTrainType(value) {
    value ? (this.isPowerTrain = true) : (this.isPowerTrain = false);
    value ? this.fetchPowertrainImages() : "";
  }

  addImageToPowerTrainCanvas(): void {
    this.powertrainCanvasItems = [
      {
        id: this.powertrainCanvasItems.length,
        src: this.existingPowertrainObj.powertrainImg,
        alt: this.existingPowertrainObj.powertrainName,
        xPercent: 10,
        yPercent: 10,
        x: 0,
        y: 0,
        widthPercent: 20,
        sensors: this.existingPowertrainObj.sensors,
      },
    ];
    this.powerTrainSensorsNumber = this.existingPowertrainObj.sensors.length;
    this.oldTemplateSensorNumber = this.existingPowertrainObj.sensors.length;
  }

  addPowerTrainSensor() {
    this.openPowertrainSensorModal = true;
  }

  closePowerTrainSensorBox(data) {
    this.openPowertrainSensorModal = false;
    if (data) {
      this.addedMoreSensors = true; // If user on edit powertrain adds more sensors then only open create-form page else if only cahgnes drag drop positions save new coordinates
      this.powertrainCanvasItems[0].sensors.push({ ...data, x: 0, y: 0 });
      this.powerTrainSensorsNumber++;
    }
  }

  deleteCurrentPowertrainSensor() {
    this.powerTrainSensorsNumber =
      this.powerTrainSensorsNumber == 1 ? 0 : this.powerTrainSensorsNumber - 1;
    this.powertrainCanvasItems[0].sensors =
      this.powertrainCanvasItems[0].sensors.filter(
        (sensor) =>
          sensor.sensor_number !== this.powertrainSelectedSensor.sensor_number
      );
    this.powertrainSelectedSensor = {};
  }

  onPowertrainSensorClick(item, i) {

    this.powertrainSelectedSensor = item.sensors[i];
    console.log(item.sensors[i],this.powertrainSelectedSensor)
  }
  savePowerTrainTemplate() {
    let finalSensors = [];

    this.powertrainCanvasItems.map((item) => {
      item.sensors.map((sensor) => {
        finalSensors.push({
          ...sensor,
        });
      });
    });
    finalSensors.sort((a, b) => a.sensor_number - b.sensor_number);
    const encodedCanvasItems = encodeURIComponent(JSON.stringify(finalSensors));
    let subsystemEncodedData =
      this.isPowerTrain &&
      encodeURIComponent(
        JSON.stringify({
          subsystem_name: this.powertrainName,
          client_id: localStorage.getItem("user_id"),
          Image_path: this.powertrainCanvasItems[0].image_path,
          subsystem_uuid: localStorage.getItem("assetBatchID") || "",
          site_id: JSON.parse(localStorage.getItem("siteID")),
          application_id: JSON.parse(localStorage.getItem("applicationID")),
          subsystem_type: "powertrain",
        })
      );
    this.router.navigate(["/powertrain-create-form"], {
      queryParams: {
        data: encodedCanvasItems,
        subsytemTableData: subsystemEncodedData,
        type: "Create Asset",
        assetType: this.isPowerTrain ? "powertrain" : "asset",
      },
      skipLocationChange: true,
    });
  }

  onPowertrainSensorDragEnd(event: CdkDragEnd, sensor: any): void {
    // Get the drag position
    const { x, y } = event.source.getFreeDragPosition();

    // Locate the image element explicitly
    const sensorElement = event.source.element.nativeElement;
    const assetElement = sensorElement
      .closest(".cursor-move")
      ?.querySelector("img") as HTMLElement;

    if (assetElement) {
      // Get image dimensions
      const imageWidth = assetElement.offsetWidth;
      const imageHeight = assetElement.offsetHeight;

      // Calculate percentage positions
      const xPercentage = (x / imageWidth) * 100;
      const yPercentage = (y / imageHeight) * 100;

      // Assign percentage positions to the sensor
      sensor.xPercentages = xPercentage;
      sensor.xPercentageNet = (sensor.xPercentage || 0) + xPercentage;
      sensor.yPercentages = yPercentage;
      sensor.yPercentageNet = (sensor.yPercentage || 0) + yPercentage;
    } else {
      console.error("Image element not found. Ensure the selector is correct.");
    }
    console.log(`OLD xyz: ${sensor.xPercentage}-${sensor.yPercentage}`);
    console.log(`NEW xyz: ${sensor.xPercentages}-${sensor.yPercentages}`);
    console.log(`NET xyz: ${sensor.xPercentageNet}-${sensor.yPercentageNet}`);
  }

  fetchPowertrainImages() {
    if (!this.powerTrainImages.length)
      this.powertrainService
        .fetchPowertrainImages(this.imagesUrl)
        .then((data: any) => {
          this.powerTrainImages = data.images;
        });
  }

  openPowertrainNameModalBox() {
    this.openPowertrainNameModal = true;
  }

  inputPowertrainName(data) {
    console.log(data);

    //Close modal to change name
    this.openPowertrainNameModal = false;

    //Assign the new name
    this.powertrainName = data.name;

    //Update new sensor positions x,y
    this.powertrainCanvasItems[0].sensors.map((sensor) => {
      sensor.xPercentage = sensor.xPercentageNet;
      sensor.yPercentage = sensor.yPercentageNet;
    });

    //Check if new sensors are added then only open form page
    if (this.addedMoreSensors) {
      this.savePowerTrainNewTemplate();
    } else {
      //api to update device_position column of subsystem table
      // "http://localhost:7777/powertrain/powertrain/sensor-postions/" +
      this.powertrainService
        .updateSensorsPosition(
          this.updatePositionurl + this.existingPowertrainObj.powertrainId,
          {
            subsystem_name: this.powertrainName,
            device_position: this.powertrainCanvasItems[0].sensors,
          }
        )
        .then(() => {
          this.router.navigate(["/detail-nxt-v2"], {
            queryParams: { isEditReturn: true },
          });
        })
        .catch(() => {
          this.service.showError("Failed to save data!");
        });
    }
  }

  goBackToDashboard(){
    this.router.navigate(["/detail-nxt-v2"], {
      queryParams: { isEditReturn: true },
    });
  }

  resetOldPowerTrain() {
    //reset the old powertrain positions and sensors if got any bug
    this.ngOnInit();
  }
  savePowerTrainNewTemplate() {
    //WORK WHEN NEW SENSORS ARE ADDED LATER ON IN EDIT PAGE
    let finalSensors = [];

    this.powertrainCanvasItems.map((item) => {
      item.sensors.map((sensor) => {
        finalSensors.push({
          ...sensor,
        });
      });
    });
    // finalSensors.sort((a, b) => a.sensor_number - b.sensor_number);
    const encodedCanvasItems = encodeURIComponent(JSON.stringify(finalSensors));
    let subsystemEncodedData = encodeURIComponent(
      JSON.stringify({
        subsystem_name: this.powertrainName,
        client_id: this.existingPowertrainObj.client_id,
        Image_path: this.existingPowertrainObj.powertrainImg,
        subsystem_uuid: this.existingPowertrainObj.subsystem_uuid,
        site_id: this.existingPowertrainObj.site_id,
        application_id: this.existingPowertrainObj.application_id,
        subsystem_type: "powertrain",
        subsystem_id: this.existingPowertrainObj.powertrainId,
      })
    );
    this.router.navigate(["/powertrain-create-form"], {
      queryParams: {
        data: encodedCanvasItems,
        subsytemTableData: subsystemEncodedData,
        type: "PowertrainUpdate",
        assetType: "powertrain",
        newIndex: this.oldTemplateSensorNumber,
      },
      skipLocationChange: true,
    });
  }
}
